import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

import { SettingsView } from './settings-view';

function settingsViewRoute(routeProps: RouteComponentProps) {
  return (
    <Route
      path={`${routeProps.match.path}/view/:id`}
      render={() => (
        <>
          <SettingsView />
        </>
      )}
    />
  );
}

export { settingsViewRoute };
